import Vue from 'vue';
import Vuex from 'vuex';
import refHousesState from "./refHousesState"
import housesState from "./housesState"
import metaDataState from "./metaDataState"

Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,

    modules: {
        houses: housesState,
        refHouses: refHousesState,
        metaData: metaDataState,
    },

    state: {
        procurementModel: -1,
        projectStateType: 0,
        projectId: 0,
        isProjectClosed: false,
        savingNotificationVisible: false,
        maxNumberOfHouses: 0
    },

    getters: {
        procurementModel: function (state) { return state.procurementModel },
        projectStateType: function (state) { return state.projectStateType },
        isProjectClosed: function (state) { return state.isProjectClosed },
        canAddMoreHouses: function (state) { return state.houses.houses.length < state.maxNumberOfHouses },
        projectId: function (state) { return state.projectId },
    },

    mutations: {
        initFromDb: function (state, payload) {
            state.houses.houses = payload.houses
            state.houses.nonResidentialFloorArea = payload.nonResidentialFloorArea || 0
            state.refHouses.referenceHouses = payload.referenceHouses
            state.procurementModel = payload.procurementModel
            state.projectStateType = payload.projectStateType
            state.projectId = payload.projectId
            state.isProjectClosed = payload.isProjectClosed
            state.maxNumberOfHouses = payload.maxNumberOfHouses
        },
        showSavingNotification(state) {
            state.savingNotificationVisible = true
        },
        hideSavingNotification(state) {
            state.savingNotificationVisible = false
        },
    }
});



// WEBPACK FOOTER //
// ./assets/vue/houseModel/store/index.js